import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { UserTrainingPlanDTO } from '../../user-training-plan/models/user-training-plan';
import { EmployeesTrainingPlanService } from '../services/employees-training-plan.service';
import { catchError, of } from 'rxjs';
import { UserProfileConstants } from '../../user-profile/user-profile-constants';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { TrainingPlanBulkActionRequest } from '../models/training-plan-bulk-action-request';
import { TrainingPlanActions, TrainingStatus } from '../../../../app/shared/enums/enum';
import { EmployeesTrainingPlanPersistenceService } from '../services/employees-training-plan-persistence.service';
import { NameCode } from '../../../shared/models/name-code';
import { TrainingPlanPanelListComponent } from '../../shared/training-plan-panel-list/training-plan-panel-list.component';
import { AppliedFilters } from '../../../shared-components/panel-hub/models/applied-filters';
import { PaginationState } from '../../../shared-components/panel-hub/models/pagination-state';
import { SortCriteria } from '../../../shared-components/panel-hub/models/sort-criteria';
import { FilterCriteriaDto } from '../../../shared/models/search/filter-dto';

@Component({
  selector: 'app-employees-training-plan-requirements',
  templateUrl: './employees-training-plan-requirements.component.html',
  styleUrls: ['./employees-training-plan-requirements.component.scss']
})
export class EmployeesTrainingPlanRequirementsComponent implements OnInit {

  selectedItemsData: UserTrainingPlanDTO[] = [];
  disableSplitButton: boolean = true;
  @Input() selectedPuid: any = '';
  @Input() isUserTerminated: boolean = false;
  @Input() isShowAll: boolean = false;

  // Selection state for pagination-aware bulk actions
  selectAllActive: boolean = false;
  selectedItemNumbers: Set<string> = new Set();
  deselectedItemNumbers: Set<string> = new Set();
  currentFilters: AppliedFilters | null = null;
  currentSort: SortCriteria | null = null;
  currentIsShowAll: boolean = false;
  currentPagination: PaginationState | null = null;

  showRevocationReasonOnClickRevokeButtonBtn = false;
  validationMessageForReasonForTrainingRevocation: string = UserProfileConstants.TrainingPlan_ReasonForRevocation;
  headingForTrainingItemRevocation: string = UserProfileConstants.ReasonForTrainingItemRevocation;
  unAssignTrainingItemGroupBtnLabel: string = UserProfileConstants.TrainingPlan_UnAssign_Training_Item_Group_Btn_Label;
  isUnAssignTrainingItemGroupSliderOpen: boolean = false;
  trainingItemGroups: NameCode[] = [];
  selectedTrainingItemGroups: string[] = [];

  @ViewChild(TrainingPlanPanelListComponent)
  trainingPlanPanelList!: TrainingPlanPanelListComponent;

  coreElectiveItems: MenuItem[];
  statusItems: MenuItem[];
  trainingStatusItems: MenuItem[];
  constructor(private employeesTrainingPlanService: EmployeesTrainingPlanService, private messageService: MessageService,
    private employeesTrainingPlanPersistenceService: EmployeesTrainingPlanPersistenceService, private confirmationService : ConfirmationService) {
    this.coreElectiveItems = [
      {
          label: TrainingPlanActions.Core,
          command: () => {
              this.updateCoreElective(TrainingPlanActions.Core);
          }
      },
      {
          label: TrainingPlanActions.Elective,
          command: () => {
              this.updateCoreElective(TrainingPlanActions.Elective);
          }
      }
  ];
  this.statusItems = [
    {
        label: TrainingPlanActions.Active,
        command: () => {
            this.updateStatus(TrainingPlanActions.Active);
        }
    },
    {
        label: TrainingPlanActions.Removed,
        command: () => {
            this.updateStatus(TrainingPlanActions.Removed);
        }
    }
];
this.trainingStatusItems = [
  {
      label: TrainingPlanActions.Revoke,
      command: () => {
        this.showRevokeReasonPopUp(TrainingPlanActions.Revoke);
      }
  },
  {
      label: TrainingPlanActions.Unlock,
      command: () => {
          this.updateTrainingStatus(TrainingPlanActions.Unlock);
      }
  }
];
  }

showRevokeReasonPopUp(revokeOrUnlock: string) {
  this.showRevocationReasonOnClickRevokeButtonBtn=true;
}

updateRevocationReasonOnRevokingTraining(revocationReasonData:string)
{
 this.updateTrainingStatus(TrainingPlanActions.Revoke,revocationReasonData);
 this.showRevocationReasonOnClickRevokeButtonBtn = false;
}

closeReasonDailog(value : boolean){    
    this.showRevocationReasonOnClickRevokeButtonBtn = value
  }


  ngOnInit(): void {
    this.employeesTrainingPlanPersistenceService.data$.subscribe((data) => {
      if (data == true) {
        this.refreshTrainingPlan();
      }
    });
    
    // Subscribe to toast messages from the persistence service
    this.employeesTrainingPlanPersistenceService.toastMessage$.subscribe((message) => {
      if (message) {
        this.messageService.add(message);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedPuid'] && !changes['selectedPuid'].firstChange) {
      // Panel list will automatically reload with new puid
    }
  }

  onSelectionChanged(event: any) {
    // Update selection state from panel-hub
    this.selectAllActive = event.isSelectAllAcrossPages || false;
    this.selectedItemNumbers = new Set(event.selectedItems || []);
    this.deselectedItemNumbers = new Set(event.deselectedItems || []);
    this.currentFilters = event.currentFilters;
    this.currentSort = event.currentSort;
    this.currentPagination = event.currentPagination;
    this.currentIsShowAll = event.isShowAll || false;

    // Update legacy selectedItemsData for backward compatibility (though not used anymore)
    this.selectedItemsData = event.selectedItems || [];
    
    // Update button state
    const hasSelection = this.selectAllActive || this.selectedItemNumbers.size > 0;
    this.disableSplitButton = this.isUserTerminated ? this.isUserTerminated : !hasSelection;
  }

  private refreshTrainingPlan() {
    if (this.trainingPlanPanelList) {
      this.trainingPlanPanelList.refreshPanel();
    }
  }  


  updateCoreElective(coreOrElective: string) {
    if (this.selectAllActive || this.selectedItemNumbers.size > 0) {
      // Build bulk action request based on selection mode
      const request: TrainingPlanBulkActionRequest = {
        puid: this.selectedPuid,
        actionName: coreOrElective,
        revocationReason: null,
        isShowAll: this.currentIsShowAll,
        isSelectAcrossAllPages: this.selectAllActive,
        
        // MODE 1: Regular selection
        selectedTrainingItemNumbers: this.selectAllActive 
          ? undefined 
          : Array.from(this.selectedItemNumbers),
        
        // MODE 2: Select All mode - convert AppliedFilters to FilterCriteriaDto
        Filter: this.selectAllActive ? this.convertToFilterCriteriaDto(this.currentFilters) : undefined,
        sort: this.selectAllActive ? this.currentSort : undefined,
        pagination: this.selectAllActive ? this.currentPagination : undefined,
        deselectedTrainingItemNumbers: this.selectAllActive 
          ? Array.from(this.deselectedItemNumbers) 
          : undefined
      };

      this.employeesTrainingPlanService.updateTrainingPlanCoreOrElective(request)
        .pipe(
          catchError((error) => {
            console.error('API Error:', error);
            this.messageService.add({
              severity: UserProfileConstants.Severity_Err,
              summary: 'Error updating training items',
              life: 5000
            });
            return of(null);
          })
        )
        .subscribe((response: any) => {
          if (response) {
            this.messageService.add({
              severity: UserProfileConstants.Severity_Success,
              summary: `Updated ${response.updated} of ${response.totalSelected} items to ${coreOrElective}`,
              life: 5000
            });
            
            // Show warning for skipped items
            if (response.skipped && response.skipped.length > 0) {
              const skippedItemsList = response.skipped.join(', ');
              this.messageService.add({
                severity: UserProfileConstants.Severity_Warning,
                summary: `The following Training Requirements have not been updated because they are already in the target state: ${skippedItemsList}`,
                life: 10000
              });
            }
            
            setTimeout(() => {
              this.refreshTrainingPlan();
            }, 2000);
          }
        });
    }
  }

  updateStatus(activeOrRemoved: string) {
    if (this.selectAllActive || this.selectedItemNumbers.size > 0) {
      // Build bulk action request based on selection mode
      const request: TrainingPlanBulkActionRequest = {
        puid: this.selectedPuid,
        actionName: activeOrRemoved,
        revocationReason: null,
        isShowAll: this.currentIsShowAll,
        isSelectAcrossAllPages: this.selectAllActive,
        
        // MODE 1: Regular selection
        selectedTrainingItemNumbers: this.selectAllActive 
          ? undefined 
          : Array.from(this.selectedItemNumbers),
        
        // MODE 2: Select All mode - convert AppliedFilters to FilterCriteriaDto
        Filter: this.selectAllActive ? this.convertToFilterCriteriaDto(this.currentFilters) : undefined,
        sort: this.selectAllActive ? this.currentSort : undefined,
        pagination: this.selectAllActive ? this.currentPagination : undefined,
        deselectedTrainingItemNumbers: this.selectAllActive 
          ? Array.from(this.deselectedItemNumbers) 
          : undefined
      };

      this.employeesTrainingPlanService.updateTrainingPlanStatus(request)
        .pipe(
          catchError((error) => {
            console.error('API Error:', error);
            this.messageService.add({
              severity: UserProfileConstants.Severity_Err,
              summary: 'Error updating training items',
              life: 5000
            });
            return of(null);
          })
        )
        .subscribe((response: any) => {
          if (response) {
            this.messageService.add({
              severity: UserProfileConstants.Severity_Success,
              summary: `Updated ${response.updated} of ${response.totalSelected} items to ${activeOrRemoved}`,
              life: 5000
            });
            
            // Show warning for skipped items
            if (response.skipped && response.skipped.length > 0) {
              const skippedItemsList = response.skipped.join(', ');
              const warningMessage = UserProfileConstants.Status_Items_in_Target_State.replace('TrainingItemsCodes', skippedItemsList);
              this.messageService.add({
                severity: UserProfileConstants.Severity_Warning,
                summary: warningMessage,
                life: 10000
              });
            }
            
            setTimeout(() => {
              this.refreshTrainingPlan();
            }, 2000);
          }
        });
    }
  } 

  updateTrainingStatus(revokeOrUnlock: string,revocationReasonData?: string | null) {
    if (this.selectAllActive || this.selectedItemNumbers.size > 0) {
      // Build bulk action request based on selection mode
      const request: TrainingPlanBulkActionRequest = {
        puid: this.selectedPuid,
        actionName: revokeOrUnlock,
        revocationReason: revocationReasonData,
        isShowAll: this.currentIsShowAll,
        isSelectAcrossAllPages: this.selectAllActive,
        
        // MODE 1: Regular selection
        selectedTrainingItemNumbers: this.selectAllActive 
          ? undefined 
          : Array.from(this.selectedItemNumbers),
        
        // MODE 2: Select All mode - convert AppliedFilters to FilterCriteriaDto
        Filter: this.selectAllActive ? this.convertToFilterCriteriaDto(this.currentFilters) : undefined,
        sort: this.selectAllActive ? this.currentSort : undefined,
        pagination: this.selectAllActive ? this.currentPagination : undefined,
        deselectedTrainingItemNumbers: this.selectAllActive 
          ? Array.from(this.deselectedItemNumbers) 
          : undefined
      };

      this.employeesTrainingPlanService.updateTrainingPlanTrainingStatus(request)
        .pipe(
          catchError((error) => {
            console.error('API Error:', error);
            this.messageService.add({
              severity: UserProfileConstants.Severity_Err,
              summary: 'Error updating training items',
              life: 5000
            });
            return of(null);
          })
        )
        .subscribe((response: any) => {
          if (response) {
            this.messageService.add({
              severity: UserProfileConstants.Severity_Success,
              summary: `Updated ${response.updated} of ${response.totalSelected} items to ${revokeOrUnlock}`,
              life: 5000
            });
            
            // Show warning for skipped items based on action
            if (response.skipped && response.skipped.length > 0) {
              const skippedItemsList = response.skipped.join(', ');
              let warningMessage: string;
              
              if (revokeOrUnlock === 'Revoke') {
                warningMessage = UserProfileConstants.TrainingStatus_Items_with_Otherthan_Complete_Status.replace('TrainingItemsCodes', skippedItemsList);
              } else if (revokeOrUnlock === 'Unlock') {
                warningMessage = UserProfileConstants.TrainingStatus_Items_with_Otherthan_Locked_Status.replace('TrainingItemsCodes', skippedItemsList);
              } else {
                warningMessage = `The following Training Requirements have not been updated: ${skippedItemsList}`;
              }
              
              this.messageService.add({
                severity: UserProfileConstants.Severity_Warning,
                summary: warningMessage,
                life: 10000
              });
            }
            
            setTimeout(() => {
              this.refreshTrainingPlan();
            }, 2000);
          }
        });
    }
  }

  reloadComponent() {
    this.refreshTrainingPlan();
  }

  openUnAssignTrainingItemGroupSlider = () =>{
    this.isUnAssignTrainingItemGroupSliderOpen = true;
    this.getTrainingItemGroupsFromTrainingPlan();
  }

  closeUnAssignTrainingItemGroupSlider = (isSliderActive : boolean) =>{
    this.isUnAssignTrainingItemGroupSliderOpen = isSliderActive;
  }

  refreshTrainingPlanOnUnAssignTrainingItemGroups = (isRefresh : boolean) =>{
    if(isRefresh){
      this.reloadComponent();
    }
  }

  getTrainingItemGroupsFromTrainingPlan = () => {
    this.employeesTrainingPlanService.getTrainingItemGroupsFromTrainingPlan(this.selectedPuid)
    .subscribe({
      next:(data) => {
        this.trainingItemGroups = data;
      },
      error:()=>{
        this.messageService.add({
          severity: UserProfileConstants.Severity_Err,
          summary: `${UserProfileConstants.TrainingPlan_Fetch_Training_Item_Group_Error_Message}`,
          sticky : false,
        });
      }
    });
  }

  selectedTrainingItemGroupsList = (selectedGroups : string[]) =>{
    this.selectedTrainingItemGroups = selectedGroups;
  }
  unAssignTrainingItemGroupsFromTrainingPlan(){
    if (this.selectedTrainingItemGroups.length === 0) return;
    
    this.employeesTrainingPlanService
      .unAssignTrainingItemGroupsFromTrainingPlan(this.selectedPuid, this.selectedTrainingItemGroups)
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: UserProfileConstants.Severity_Success,
            summary: UserProfileConstants.TrainingPlan_UnAssign_Training_Item_Group_Success_Message,
            sticky: false
          });
          this.closeUnAssignTrainingItemGroupSlider(false);
          this.refreshTrainingPlanOnUnAssignTrainingItemGroups(true);
        },
        error: () => {
          this.messageService.add({
            severity: UserProfileConstants.Severity_Err,
            summary: UserProfileConstants.TrainingPlan_UnAssign_Training_Item_Group_Error_Message,
            sticky: false
          });
          this.refreshTrainingPlanOnUnAssignTrainingItemGroups(false);
          this.closeUnAssignTrainingItemGroupSlider(false);
        }
      });
  }

  /**
   * Convert AppliedFilters to FilterCriteriaDto to match backend DTO structure
   */
  private convertToFilterCriteriaDto(appliedFilters: AppliedFilters | null): FilterCriteriaDto | null {
    if (!appliedFilters) {
      return null;
    }

    return {
      SearchText: appliedFilters.searchText || null,
      FilterItems: appliedFilters.filters.map(f => ({
        Field: f.field,
        Values: f.values,
        Type: f.type
      }))
    };
  }
  
}

